import { styled } from '@mui/system'
import { TTheme } from '@/core/theme'

export const ActivateButton = styled('div')<{ theme?: TTheme }>`
    display: flex;
    align-items: center;
    gap: 6px;
    cursor: pointer;
    &:hover {
        .text {
            color: ${({ theme }) =>
                theme.colors.semantic.activationButtonHover};
        }
        svg {
            color: ${({ theme }) =>
                theme.colors.semantic.activationButtonHover};
        }
    }
`
